import { render, staticRenderFns } from "./VideoComp.vue?vue&type=template&id=114e2a8d&"
import script from "./VideoComp.vue?vue&type=script&lang=js&"
export * from "./VideoComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports